import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { sheetFabrics } from "@/lib/modelSheets";

const eur = (n) => (Number(n) || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
const key = (f) => `${f.fabric_type || ""}|${f.name || ""}`.toLowerCase();

export const useFabricPrices = (s) => useQuery({
  queryKey: ["model-sheet-fabric-prices", s.id, s.updated_at],
  queryFn: async () => (await api.get(`/model-sheets/${s.id}/fabric-prices`)).data,
  enabled: !!s.id,
});

export const fabricLines = (s, auto = []) => {
  return sheetFabrics({ tech: { fabrics: s.tech?.fabrics || [] } }).map((f) => {
    const a = auto.find((x) => x.key === key(f)) || {};
    const manual = s.costs?.fabric_prices?.[key(f)];
    const price = manual !== undefined && manual !== null && manual !== "" ? Number(manual) : a.price;
    return { f, k: key(f), auto: a, manual, price, cost: (Number(f.meters_per_piece) || 0) * (Number(price) || 0) };
  });
};

const Source = ({ a }) => {
  if (a.source === "nome") return <span>da materie prime{a.supplier ? ` · ${a.supplier}` : ""}</span>;
  if (a.source === "tipo") return <span className="text-amber-400">prezzo più basso per il tipo{a.supplier ? ` · ${a.supplier}` : ""}</span>;
  return <span className="text-rose-400">prezzo non trovato: inseriscilo a mano</span>;
};

export const FabricCosts = ({ lines, onPrice, onMeters }) => (
  <div className="overflow-x-auto rounded-md border border-border">
    <table className="w-full text-sm" data-testid="stylist-fabric-costs">
      <thead><tr className="border-b border-border text-xs text-muted-foreground">
        <th className="p-2 text-left font-medium">Tessuto</th><th className="p-2 text-right font-medium">Metri per capo</th>
        <th className="p-2 text-right font-medium">Prezzo al metro (€)</th><th className="p-2 text-right font-medium">Costo</th>
      </tr></thead>
      <tbody>
        {lines.map((l, i) => (
          <tr key={i} className="border-b border-border/50 last:border-0" data-testid={`stylist-fabric-${i}`}>
            <td className="p-2"><p>{l.f.fabric_type || "-"}{l.f.name ? ` · ${l.f.name}` : ""}</p><p className="text-[11px] text-muted-foreground"><Source a={l.auto} /></p></td>
            <td className="p-2 text-right">
              <Input type="number" min="0" step="0.01" value={l.f.meters_per_piece ?? ""} placeholder="0" onChange={(e) => onMeters(i, e.target.value)}
                className={`no-spin ml-auto h-8 w-20 text-right ${l.f.meters_per_piece ? "" : "border-rose-500/60"}`} data-testid={`stylist-fabric-${i}-mpp`} />
            </td>
            <td className="p-2 text-right">
              <Input type="number" min="0" step="0.01" value={l.manual ?? ""} placeholder={l.auto.price != null ? String(l.auto.price) : "0"}
                onChange={(e) => onPrice(l.k, e.target.value)} className="ml-auto h-8 w-24 text-right" data-testid={`stylist-fabric-${i}-price`} />
            </td>
            <td className="p-2 text-right font-medium" data-testid={`stylist-fabric-${i}-cost`}>{eur(l.cost)}</td>
          </tr>
        ))}
        {!lines.length && <tr><td colSpan={4} className="p-3 text-xs text-muted-foreground">Nessun tessuto nella versione modelliste.</td></tr>}
      </tbody>
    </table>
  </div>
);
